import { type SplitState, SplitVuexModule } from '@smg-real-estate/vue-experiments';
import { createStore as _createStore, type Store } from 'vuex';

export interface SplitStoreState {
  split: SplitState;
}

export const createSplitStore = (): Store<SplitStoreState> =>
  _createStore({
    modules: {
      split: SplitVuexModule,
    },
  });
